import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from "recharts";
import THEME from "../../../theme";
import { fs } from "../utils/styles";

// Alle Kostenarten-Zeilen der BWA (siehe BWA_KATEGORIEN in backend/bwa_pdf_parser.py) - als
// gestapeltes Flaechendiagramm, damit man die Kostenzusammensetzung ueber die Zeit sieht statt
// nur eine einzelne "Gesamtkosten"-Linie. Kategorien, die ueber die gesamte Historie immer 0
// sind (z.B. "Betriebliche Steuern" bei diesem Studio), werden automatisch ausgeblendet.
const KOSTENARTEN_SCHLUESSEL = [
  "personalkosten", "raumkosten", "versicherungen_beitraege", "fahrzeugkosten",
  "werbe_reisekosten", "abschreibungen", "reparatur_instandhaltung", "sonstige_kosten",
  "betriebliche_steuern", "besondere_kosten", "kosten_warenabgabe",
];
const FARBEN = [
  THEME.colors.primary, THEME.colors.accentCyan, THEME.colors.accentOrange, THEME.colors.accentPurple,
  THEME.colors.accentPink, THEME.colors.accentGreenDark, THEME.colors.warning, THEME.colors.accentViolet,
];

export default function BwaKostenaufschluesselung({ trend }) {
  if (!trend || !trend.monate || trend.monate.length === 0) return null;

  const aktive = KOSTENARTEN_SCHLUESSEL.filter(schluessel => {
    const serie = trend.serien[schluessel];
    return serie && serie.werte.some(w => w != null && w !== 0);
  });
  if (aktive.length === 0) return null;

  const daten = trend.monate.map((label, i) => {
    const zeile = { label };
    for (const schluessel of aktive) {
      zeile[trend.serien[schluessel].bezeichnung] = trend.serien[schluessel].werte[i] ?? 0;
    }
    return zeile;
  });

  return (
    <div style={fs.karte}>
      <h3 style={{ color: THEME.colors.text, marginTop: 0 }}>Kostenaufschlüsselung über die Zeit</h3>
      <ResponsiveContainer width="100%" height={320}>
        <AreaChart data={daten}>
          <CartesianGrid strokeDasharray="3 3" stroke={THEME.colors.border} />
          <XAxis dataKey="label" stroke={THEME.colors.textMuted} fontSize={12} />
          <YAxis stroke={THEME.colors.textMuted} fontSize={12} />
          <Tooltip contentStyle={{ background: THEME.colors.surface, border: `1px solid ${THEME.colors.border}`, color: THEME.colors.text }} />
          <Legend />
          {aktive.map((schluessel, i) => (
            <Area
              key={schluessel} type="monotone" dataKey={trend.serien[schluessel].bezeichnung} stackId="kosten"
              stroke={FARBEN[i % FARBEN.length]} fill={FARBEN[i % FARBEN.length]} fillOpacity={0.55}
            />
          ))}
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
